module.exports = "<div class=\"contentWrapper vehicleUsages\">\n</div>"